module.exports = __webpack_public_path__ + "media/icons/caret-down-1ef0ba63.svg";